import { getWithRootPathGetter, replacePathParams } from '@/api/utils';

const withRoot = getWithRootPathGetter('/oposervice');

export const opoApiPaths = {
  organizations: withRoot('/organizations'),
  organizationById: withRoot('/organizations/:organizationId'),
  contacts: withRoot('/contacts'),
  contactById: withRoot('/contacts/:contactId'),
  contactByUserId: withRoot('/contact/userid/:userId'),
  opoUsers: withRoot('/opo-users'),
  opoUserByContactId: withRoot('/opo-users/:contactId'),
  opoUserOperationByCorrelationId: withRoot('/opo-users/operations/:correlationId'),
} as const;

export const getOpoApiUrl = {
  organizations: () => opoApiPaths.organizations,
  organizationById: (organizationId: string) => replacePathParams(opoApiPaths.organizationById, { organizationId }),
  contacts: () => opoApiPaths.contacts,
  contactById: (contactId: string) => replacePathParams(opoApiPaths.contactById, { contactId }),
  contactByUserId: (userId: string) => replacePathParams(opoApiPaths.contactByUserId, { userId }),
  opoUsers: () => opoApiPaths.opoUsers,
  opoUserByContactId: (contactId: string) => replacePathParams(opoApiPaths.opoUserByContactId, { contactId }),
  opoUserOperationByCorrelationId: (correlationId: string) =>
    replacePathParams(opoApiPaths.opoUserOperationByCorrelationId, { correlationId }),
};
